module.exports = __webpack_public_path__ + "img/slider_8.fd35ceba.jpg";